import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { message, Modal as AntdModal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button } from 'ui';
import apiClient from 'utils/apiClient';
import useHandleError from 'utils/useHandleError';
import generalHelpers from 'utils/generalHelpers';

const mapStateToProps = (state: any) => ({
    session: state.session,
});

interface RegenerateTaskButtonInterface {
    attemptId: number;
    onDone: Function;
    session?: any;
}

/**
 * 24.3.8 - PowerAdmin regenerates a deleted grading task (ASSESSMENT/ASSIGNMENT).
 * Renders nothing for users without the delete_grading_tasks special right.
 */
const RegenerateTaskButton: React.FC<RegenerateTaskButtonInterface> = ({
    attemptId,
    onDone,
    session,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const intl = useIntl();
    const [handleError] = useHandleError();

    if (!generalHelpers.hasSpecialPermissions(session, 'delete_grading_tasks')) {
        return null;
    }

    const regenerate = () => {
        AntdModal.confirm({
            title: intl.formatMessage({ id: 'grading.regenerate_task' }),
            icon: <ExclamationCircleOutlined />,
            content: intl.formatMessage({ id: 'grading.regenerate_task_confirm' }),
            okText: intl.formatMessage({ id: 'general.confirm' }),
            cancelText: intl.formatMessage({ id: 'general.cancel' }),
            onOk: async () => {
                setIsLoading(true);
                try {
                    await apiClient.request(`/api/v1/courses/grading/regenerate-task/${attemptId}`, {}, 'POST');
                    message.success(intl.formatMessage({ id: 'grading.task_regenerated_success' }));
                    onDone();
                } catch (error) {
                    handleError(error);
                } finally {
                    setIsLoading(false);
                }
            },
        });
    };

    return (
        <Button
            loading={isLoading}
            onClick={() => regenerate()}
            message="grading.regenerate_task"
        />
    );
};

export default connect(mapStateToProps)(RegenerateTaskButton);
